import state from './contact.state'

export default {
  state
}
